/**
 * Cart drawer extras - keeps "Customers Also Bought" upsells in sync with the
 * cart, and wires up the discount code Apply button so customers can redeem
 * codes without leaving the drawer.
 *
 * Loaded once via cart-drawer.liquid. Subscribes to the theme's pubsub
 * `cart-update` event so it re-runs on every cart change (add, remove, qty),
 * not just on initial page load.
 */
;(function () {
  // ??????????????????????? Money formatter ???????????????????????
  function formatMoney(cents) {
    if (typeof window.formatMoney === 'function') {
      try {
        return window.formatMoney(cents)
      } catch (e) {
        /* fall through to manual format */
      }
    }
    const amount = (cents / 100).toFixed(2).replace('.', ',')
    return amount + ' kr'
  }

  // ??????????????????????? Upsells ???????????????????????
  //
  // Renders the SAME product-card snippet as collection pages - so the
  // hover overlay (Subscribe & Save / Add to cart), title, subtitle and
  // price all match. We fetch Shopify's section-rendering endpoint with
  // `section_id=cart-recommendations`; Shopify populates the
  // `recommendations` Liquid object and returns the section's HTML, which
  // we drop straight into the cart drawer.
  //
  // Endpoint: /recommendations/products?section_id=cart-recommendations
  //           &product_id=<id>&limit=4&intent=related
  // We request 4 picks so we can filter out anything that's already in
  // the cart and still have 3 cards to show.
  function loadUpsells() {
    const container = document.getElementById('cart-upsell-products')
    if (!container) return

    fetch('/cart.js', { credentials: 'same-origin' })
      .then((res) => res.json())
      .then((cart) => {
        if (!cart.items || !cart.items.length) {
          container.innerHTML = ''
          return
        }
        const productId = cart.items[0].product_id
        // Prefix with Shopify.routes.root so the request keeps the active
        // locale (e.g. /da/recommendations/...) — otherwise Shopify renders
        // the section in the shop's default locale (EN) and the ADD button
        // text comes back as "Add" instead of the localized "Tilføj" etc.
        // (customer fb 22/05 2026).
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
        // limit=8 so that after dropping in-cart products we can still fill
        // 3 cards from personalized picks alone in most cases.
        const url = `${root}recommendations/products?section_id=cart-recommendations&product_id=${productId}&limit=8&intent=related`
        return fetch(url, { credentials: 'same-origin' })
          .then((res) => res.text())
          .then((html) => {
            // The section endpoint returns HTML wrapped in a <div id="shopify-section-cart-recommendations">.
            // Pull out the actual list element.
            const doc = new DOMParser().parseFromString(html, 'text/html')
            const list = doc.querySelector('#cart-recommendations-list')
            if (!list) {
              // Keep the server-rendered bestseller fallback that
              // cart-drawer.liquid already put in the container — never
              // leave an empty void under the heading.
              return
            }
            // Cards currently in the container (server-rendered bestseller
            // fallback, or the previous render) — used to top up below so
            // the grid always shows 3 products (merchant request, Jun 2026).
            const reserveCards = Array.from(container.querySelectorAll('.cart-recommendations__card'))
            // Drop any card whose product is already in the cart, then
            // cap at 3 to keep the grid tidy.
            const cartIds = new Set(cart.items.map((i) => String(i.product_id)))
            const cards = list.querySelectorAll('[data-product-id]')
            let shown = 0
            cards.forEach((card) => {
              if (cartIds.has(card.dataset.productId) || shown >= 3) {
                card.remove()
              } else {
                shown += 1
              }
            })
            if (shown === 0) {
              // Everything Shopify suggested is already in the cart —
              // keep the fallback cards instead of showing nothing.
              return
            }
            if (shown < 3) {
              // Top up from the reserve so the customer always sees 3.
              const have = new Set(
                Array.from(list.querySelectorAll('[data-product-id]')).map((c) => c.dataset.productId)
              )
              for (const rc of reserveCards) {
                if (shown >= 3) break
                const pid = rc.dataset.productId
                if (!pid || have.has(pid) || cartIds.has(pid)) continue
                list.appendChild(rc.cloneNode(true))
                have.add(pid)
                shown += 1
              }
            }
            container.innerHTML = ''
            container.appendChild(list)
          })
      })
      .catch(function (err) {
        console.warn('[cart-upsells] failed to load', err)
      })
  }

  // Re-fetch the cart drawer HTML and swap it in. Used after add-from-upsell
  // and other actions that need a full re-render.
  function refreshCartDrawer() {
    // Samme sprog-faelde som i loadUpsells ovenfor: uden Shopify.routes.root
    // gentegner Shopify kurven i butikkens standardsprog (EN), saa de- og
    // nl-kunder pludselig staar med en engelsk kurv efter en opdatering.
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
    return fetch(root + '?section_id=cart-drawer', { credentials: 'same-origin' })
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html')
        const newInner = doc.querySelector('#CartDrawer .drawer__inner')
        const currentInner = document.querySelector('#CartDrawer .drawer__inner')
        if (newInner && currentInner) {
          currentInner.innerHTML = newInner.innerHTML
        }
        const drawer = document.querySelector('cart-drawer')
        if (drawer && typeof drawer.open === 'function') drawer.open()
        loadUpsells()
        // Tell any code that needs to re-bind after a drawer rebuild that
        // this DOM was just replaced. cart-drawer.js's renderContents
        // dispatches this event but our manual refresh path skipped it -
        // which left the terms-checkbox/checkout-button init stuck (the
        // listeners were attached to the old, now-discarded DOM nodes).
        try {
          document.dispatchEvent(new CustomEvent('cart-drawer:rendered'))
        } catch (_) {}
      })
  }

  // global.js gentegner kurven efter en rabatkode er fjernet.
  window.refreshCartDrawer = refreshCartDrawer

  // Click handler for upsell ADD buttons (delegated so it survives re-renders).
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.upsell-add')
    if (!btn) return
    e.preventDefault()
    const id = btn.dataset.id
    if (!id) return
    btn.disabled = true
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
    })
      .then((res) => res.json())
      .then(refreshCartDrawer)
      .catch(() => {
        btn.disabled = false
      })
  })

  // ??? VV+ loyalty banner dismiss (per session) ???
  document.addEventListener('click', function (e) {
    const closeBtn = e.target.closest('[data-vv-loyalty-dismiss]')
    if (!closeBtn) return
    e.preventDefault()
    const banner = closeBtn.closest('#VVLoyaltyBanner')
    if (!banner) return
    banner.classList.add('is-dismissed')
    try { sessionStorage.setItem('vv_loyalty_banner_dismissed', '1') } catch (_) {}
  })
  // Re-apply dismissed state after re-render
  function applyLoyaltyDismissal() {
    try {
      if (sessionStorage.getItem('vv_loyalty_banner_dismissed') === '1') {
        const b = document.getElementById('VVLoyaltyBanner')
        if (b) b.classList.add('is-dismissed')
      }
    } catch (_) {}
  }
  if (document.readyState !== 'loading') applyLoyaltyDismissal()
  else document.addEventListener('DOMContentLoaded', applyLoyaltyDismissal)
  document.addEventListener('cart-drawer:rendered', applyLoyaltyDismissal)

  // === "Customers Also Bought" - visible Tilføj buttons (no hover) ===
  // The new cart-recommendations.liquid renders each card with its own
  // <form> + a .cart-recommendations__add-btn button. Delegate clicks so
  // we don't need to re-bind after every section render.
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.cart-recommendations__add-btn')
    if (!btn) return
    e.preventDefault()
    const form = btn.closest('form')
    if (!form) return
    btn.disabled = true
    const origText = btn.textContent
    btn.textContent = '…' // loading indicator (was corrupted to '.' by an earlier non-UTF8 file push)
    const body = new FormData(form)
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
    })
      .then((r) => r.json())
      .then(function () {
        btn.textContent = '✓' // success checkmark (was corrupted to '?' by an earlier non-UTF8 file push)
        setTimeout(function () {
          btn.textContent = origText
        }, 1200)
        return refreshCartDrawer()
      })
      .catch(function () {
        btn.textContent = origText
        btn.disabled = false
      })
  })

  // ??????????????????????? Discount code ???????????????????????
  // Apply via Storefront's /discount/CODE endpoint, then refresh the drawer
  // so cart-level discount lines + totals update.
  function bindDiscountForm(root) {
    const scope = root || document
    const btn = scope.querySelector('.cart-drawer__discount-btn')
    const input = scope.querySelector('.cart-drawer__discount-input')
    const feedback = scope.querySelector('.cart-drawer__discount-feedback')
    if (!btn || !input || btn.dataset.bound === '1') return
    btn.dataset.bound = '1'

    const applyLabel = btn.dataset.applyLabel || btn.textContent.trim() || 'Apply'
    const appliedLabel = btn.dataset.appliedLabel || 'Discount applied'
    const errorLabel = btn.dataset.errorLabel || 'Enter a valid discount code'

    function setFeedback(message, ok) {
      if (!feedback) return
      feedback.textContent = message || ''
      feedback.classList.toggle('cart-drawer__discount-feedback--success', ok === true)
      feedback.classList.toggle('cart-drawer__discount-feedback--error', ok === false)
    }

    function applyCode() {
      const raw = (input.value || '').trim()
      if (!raw) {
        setFeedback(errorLabel, false)
        return
      }
      const code = encodeURIComponent(raw)
      btn.disabled = true
      btn.textContent = '…' // loading indicator (was corrupted to '.' by an earlier non-UTF8 file push)

      // Hit the discount-code endpoint and ignore the redirect; we only want
      // the cookie to be set. Then update the cart with discount + refresh.
      fetch('/discount/' + code, {
        credentials: 'same-origin',
        redirect: 'follow',
      })
        .then(() =>
          fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ discount: raw }),
          })
            .then((res) => res.json())
            .catch(() => null)
        )
        .then(() => fetch('/cart.js', { credentials: 'same-origin' }))
        .then((res) => res.json())
        .then((cart) => {
          const hasDiscount = (cart.cart_level_discount_applications || []).some(
            (a) => (a.title || '').toUpperCase() === raw.toUpperCase()
          )
          if (hasDiscount) {
            setFeedback(appliedLabel, true)
            input.value = ''
          } else {
            setFeedback(errorLabel, false)
          }
          // Always refresh the drawer - totals and any line-item discount UIs
          // need to re-render either way.
          return refreshCartDrawer()
        })
        .finally(() => {
          // After refreshCartDrawer the old btn is gone; re-bind on the new one.
          const next = document.querySelector('.cart-drawer__discount-btn')
          if (next) {
            next.disabled = false
            next.textContent = applyLabel
          } else {
            btn.disabled = false
            btn.textContent = applyLabel
          }
        })
    }

    btn.addEventListener('click', applyCode)
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault()
        applyCode()
      }
    })
  }

  // ??????????????????????? Free-shipping progress ???????????????????????
  // The cart drawer renders snippets/cart-shipping-slider.liquid but the
  // theme's progress-bar JS lives inside the <cart-items> custom element
  // which only exists on the cart page. So the drawer's progress bar
  // never updated. Recompute it here on every render.
  function updateShippingProgress() {
    const shipping = document.querySelector('#CartDrawer .cart-shipping')
    if (!shipping) return
    const total = parseInt(shipping.dataset.total, 10) || 0
    const minSpend = parseInt(shipping.dataset.minSpend, 10) || 0
    if (!minSpend) return

    // Both data-total (cart.total_price from Liquid) and data-min-spend
    // (when data-presentment-cents="true") are already in the customer's
    // PRESENTMENT currency cents - no conversion needed. If a future
    // caller sets the threshold as shop-currency cents instead, we'd
    // need to multiply by Shopify.currency.rate here.
    const isPresentment = shipping.dataset.presentmentCents === 'true'
    const rate = (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.rate) || 1
    const minTotal = isPresentment ? minSpend : Math.round(minSpend * rate)

    let progress = (total / minTotal) * 100
    if (progress > 100) progress = 100

    const defaultMsg = shipping.querySelector('.cart-shipping__message_default')
    const successMsg = shipping.querySelector('.cart-shipping__message_success')
    const bar = shipping.querySelector('.cart-shipping__progress-current')

    if (minTotal > total) {
      const amountAway = minTotal - total
      const template = (shipping.dataset.message || '').trim()
      const formatted = formatMoney(amountAway)
      if (defaultMsg) defaultMsg.innerText = template.replace('||amount||', formatted)
      if (defaultMsg) defaultMsg.classList.add('active')
      if (successMsg) successMsg.classList.remove('active')
    } else {
      if (defaultMsg) defaultMsg.classList.remove('active')
      if (successMsg) successMsg.classList.add('active')
    }

    if (bar) bar.style.width = progress + '%'
  }

  // ??????????????????????? Init ???????????????????????
  function init() {
    loadUpsells()
    bindDiscountForm(document)
    updateShippingProgress()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }

  // Re-run on every cart update (add / remove / qty change). The theme's
  // pubsub pushes `cart-update` events through the `subscribe` helper.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      // Small delay lets the drawer finish its own re-render before we touch the DOM.
      setTimeout(init, 50)
    })
  }

  // Belt-and-braces: also listen for the generic `cart:updated` DOM event
  // that some pages dispatch.
  document.addEventListener('cart:updated', function () {
    setTimeout(init, 50)
  })
})()
